import Swal from "sweetalert2";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function putMovimento(
  MovimentoId: number, 
  movimentoAtual: any, 
  onSuccess: () => void, 
) {
  return await api.put(`${URLS.MOVIMENTOS_API}/${MovimentoId}`, movimentoAtual)
  .then((response) => {
    console.log(response);
    Swal.fire({
      title: 'Movimento Editado',
      text: 'O movimento foi editado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'OK',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then((response) => {
      if(response.isConfirmed) {
        onSuccess();
      }
    })
  })
  .catch((err) => {
    console.log(err.message);
    if(err.response.status === 500){
      Swal.fire({
        title: `Erro de status: ${err.response.status}`,
        text: `Ocorreu um erro ao editar o movimento. Por favor, entre em contato com um administrador do sistema.`,
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F27474',
        allowOutsideClick: false
      })
    }
    if(err.response.status === 400){
      Swal.fire({
        title: 'Erro ao editar movimento',
        text: err.response.data.message,
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F27474',
        allowOutsideClick: false
      })
      
    }
  });
}
